//
//
//
//
//
//
//
//
//
//
//
//

import box from './box.vue';
export default {
  props: ['data'],
  components: { box: box },
  methods: {
    createUrl: function createUrl(id, uniqueID) {
      return 'https://api.musubi-thai.com/api/v1.0/file/prodTask/' + id + '/' + uniqueID;
    },
    createIcon: function createIcon(mineType) {
      if (mineType === 'pdf') {
        return 'fa fa-file-pdf-o';
      }
      return 'fa fa-image';
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/related-document-task.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/related-document-task.vue
// module chunks = 2 3